"use strict";
/* globals module */
/**
 * @module filesACLClient
 * @description  Files ACL Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var FilesACLClient = /** @class */ (function () {
    function FilesACLClient(filesACLRoute, apiClient) {
        this.filesACLRoute = filesACLRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(FilesACLClient.prototype, "routeDefinition", {
        get: function () {
            return this.filesACLRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a list of ACL policies established for the specified file resource.
     * @method
     * @param options ACL options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example filesACLClient.get({id: '<file-id>'})
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    FilesACLClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update acl action has been performed, this action creates new ACL policy for the specified file resource.
     * @method
     * @param options An ACL policy object that needs to be inserted into the system. This object specifies parameters necessary for establishing user and/or role set of rights.
     * @example let options = {id : '<file-id>'};
                let aclObj =  {  actionId: '<action-id>',  roleId: '<role-id>',  userId: '<user-id>' };
                options[baasicConstants.modelPropertyName] = aclObj;
                filesACLClient.update(options)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    FilesACLClient.prototype.update = function (options) {
        return this.apiClient.put(this.routeDefinition.update(options), this.routeDefinition.updateParams(options));
    };
    /**
     * Returns a promise that is resolved once the removeByUser action has been performed. This action deletes ACL policy assigned to the specified user and file resource.
     * @method
     * @param id File id which uniquely identifies file resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and file resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @returns A promise that is resolved once the removeByUser action has been performed.
     * @example filesACLClient.removeByUser('<file-id>', '<access-action>', '<username>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    FilesACLClient.prototype.removeByUser = function (id, action, user, data) {
        return this.apiClient.delete(this.filesACLRoute.deleteByUser(id, action, user, data));
    };
    /**
     * Returns a promise that is resolved once the removeByRole action has been performed. This action deletes ACL policy assigned to the specified role and file resource.
     * @method
     * @example filesACLClient.removeByRole('<file-id>', '<access-action>', '<role-name>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    FilesACLClient.prototype.removeByRole = function (id, action, role, data) {
        return this.apiClient.delete(this.filesACLRoute.deleteByRole(id, action, role, data));
    };
    var _a, _b;
    FilesACLClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.FilesACLRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.FilesACLRoute !== "undefined" && _1.FilesACLRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], FilesACLClient);
    return FilesACLClient;
}());
exports.FilesACLClient = FilesACLClient;
/**
 * @overview
***Notes:**
- Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
- All end-point objects are transformed by the associated route service.
*/ 
